import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import Logo from '../Images/KonjoImage.png';




function Footer() {
  return (


    <div className='footer-container'>

      <div className='footer-links'>
      </div>
      <section className='social-media'>
        <div className='social-media-wrap'>
          <div className='footer-logo'>
            <Link to='/' className='social-logo'>
            <img className= 'navbar-icon' width='60px' src={Logo} />
              Konjo Dating App 🌻
            </Link>
          </div>
          <small className='website-rights'>All Rights Reserved EDR LLC {new Date().getFullYear()}</small>
        </div>
      </section>
    </div>
  );
}

export default Footer;